export default __webpack_public_path__ + "static/11004-cc3aa7a564521aac70986e8522d8f611.jpg";